import { Outlet, Navigate } from 'react-router-dom';

import TagsPage from 'src/pages/tags/TagsPage';
import LoginPage from 'src/pages/Login/loginPage';
import ProfilePage from 'src/pages/profile/ProfilePage';
import GroupUsersPage from 'src/pages/groupUsers/GroupUsersPage';
import TicketDetailsPage from 'src/pages/ticketDetails/TicketDetailsPage';

import Page404 from '../pages/404/Page404';
import SimpleLayout from '../layouts/simple';
import Status from '../pages/statuses/Status';
import FormsPage from '../pages/forms/FormsPage';
import UsersPage from '../pages/users/UsersPage';
import DashboardLayout from '../layouts/dashboard';
import NewFormPage from '../pages/forms/NewFormPage';
import TicketsPage from '../pages/tickets/TicketsPage';
import AssignmentsCalendar from '../pages/calendar/AssignmentsCalendar';
import CreateTicketPage from '../pages/ticketCreation/CreateTicketPage';
import ShareableFormsPage from '../pages/shareableForms/ShareableFormsPage';
import { ProtectedRoute } from '../components/protected-route/ProtectedRoute';
import DepartmentManagerDashboard from '../pages/dashboards/DepartmentManagerDashboard';
// ----------------------------------------------------------------------

const DepManagerRoutes = {
  path: '/',
  element: <Outlet />,
  children: [
    {
      path: '/dashboard',
      element: (
        <ProtectedRoute>
          <DashboardLayout />
        </ProtectedRoute>
      ),
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: 'app', element: <DepartmentManagerDashboard /> },
        { path: 'tickets', element: <TicketsPage /> },
        { path: 'user', element: <UsersPage title="agents" /> },
        { path: 'profile', element: <ProfilePage /> },
        { path: 'newTicket', element: <CreateTicketPage /> },
        { path: 'calendar', element: <AssignmentsCalendar /> },
        { path: 'forms', element: <FormsPage /> },
        { path: 'NewForm', element: <NewFormPage /> },
        { path: 'Status', element: <Status /> },
        { path: 'tags', element: <TagsPage /> },
        { path: 'shareableForms', element: <ShareableFormsPage /> },
        { path: 'myGroups', element: <GroupUsersPage /> },
      ],
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    { path: 'tickets/:ticketId', element: <TicketDetailsPage /> },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ],
};

export default DepManagerRoutes;
